import { useContext } from 'react'
import { AppContext } from 'shared'

export function useShowFakeButtons() {
  const ctx = useContext(AppContext)

  if (ctx.appConfigLoading) return
  return !ctx.paymentLiveMode
}
